export default class animateInView {
  constructor(el) {
    this.el = el;
    this.animation = el.getAttribute('data-animate-in-view');
    this.applyInitialStyles();
    this.createInViewObserver();
  }

  // Applied the initial styles required for the defined animation.
  // i.e. if the element is intended to animate in from the bottom,
  // apply a transform that moves it down.
  applyInitialStyles() {
    if (typeof this[this.animation] === 'function') {
      this[this.animation]();
    }
  }

  animateIn() {
    this.el.addEventListener('transitionend', () => this.cleanup());
    window.requestAnimationFrame(() => {
      Object.assign(this.el.style, {
        transition: 'all 400ms ease-in-out 100ms',
        transform: 'none',
        opacity: 1,
      });
    });
  }

  cleanup() {
    this.el.removeAttribute('data-animate-in-view');
    this.el.style.transform = '';
    this.el.style.transition = '';
    this.el.style.opacity = '';
  }

  createInViewObserver() {
    const inViewObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 0.1) {
          this.animateIn();
          inViewObserver.unobserve(this.el);
        }
      });
    }, {
      threshold: [0,0.1,1],
    });
    inViewObserver.observe(this.el);
    return inViewObserver;
  }

  /**
   * Animation Functions
   */

  closestSide() {
    const rect = this.el.getBoundingClientRect();
    const fromLeft = rect.left <= window.innerWidth - rect.right;
    Object.assign(this.el.style, {
      transform: `translateX(${fromLeft ? '-' : ''}1.5rem)`,
    });
  }

  fromBottom() {
    Object.assign(this.el.style, {
      transform: 'translateY(1.5rem)',
    });
  }

  fromRight() {
    Object.assign(this.el.style, {
      transform: 'translateX(-1.5rem)',
    });
  }

  fromLeft() {
    Object.assign(this.el.style, {
      transform: 'translateX(1.5rem)',
    });
  }
}
